/**
 * Navigation service for handling programmatic navigation outside of React components
 * This service allows navigation from API interceptors and other non-React contexts
 */

import { REACT_APP_NAV_ROUTES } from "../router/AppNavigation";

class NavigationService {
  private navigateFunction: ((path: string) => void) | null = null;

  /**
   * Set the navigate function from React Router
   * This should be called from the main App component or router setup
   */
  setNavigateFunction(navigate: (path: string) => void) {
    this.navigateFunction = navigate;
  }

  /**
   * Navigate to a specific path
   * @param path - The path to navigate to
   */
  navigate(path: string) {
    if (this.navigateFunction) {
      this.navigateFunction(path);
    } else {
      // Fallback to window.location if navigate function is not set
      console.warn(
        "Navigation service not initialized, falling back to window.location",
      );
      window.location.href = path;
    }
  }

  /**
   * Navigate to subscription required page
   * @param statusCode - The HTTP status code (402 for expired, 406 for no subscription)
   */
  navigateToSubscriptionRequired(statusCode?: number) {
    let url = `${REACT_APP_NAV_ROUTES.subscription.choose}`
    if (statusCode) {
      url += `?code=${statusCode}`
    }

    this.navigate(url);
  }

  /**
   * Navigate to access denied page
   */
  navigateToAccessDenied() {
    this.navigate("/access");
  }

  /**
   * Navigate to home page
   */
  navigateToHome() {
    this.navigate("/");
  }
}

// Export a singleton instance
export const navigationService = new NavigationService();
export default navigationService;
